import { core } from '@/core'
import Basic from '@basic'
import { Input, Scrollbar, Suggestions } from '@bag'

const util = {
  pullInput(opt, tar) {
    const option = {
      type: 'text',
    }
    const input = new Input(Object.assign({}, opt, option))
    tar.unit.append(input.unit)
    return input
  },
  pullDropdown(opt, tar) {
    const dropdown = new Suggestions({})
    dropdown.width = tar.input.unit.width()
    tar.unit.append(dropdown.unit)
    return dropdown
  },
  pullScroll(opt, tar) {
    const option = {
      tag: 'ul',
      viewClass: 'autocomplete-suggestion__list',
      wrapClass: 'autocomplete-suggestion__wrap',
    }
    const scroll = new Scrollbar(option)
    tar.dropdown.slot = scroll.unit
    return scroll
  },
  pullOption(opt, tar, value) {
    const { text = 'text' } = opt
    if ($.type(value) === 'array') {
      const div = $('<div></div>')
      tar.members.option && tar.members.option.map(node => node.unbind())
      tar.members.option = value.map(item => {
        const label = item[text]
        const option = this.template.li(label)
        option.click($.proxy(tar.handleOptionClick, tar, label))
        div.append(option)
        return option
      })
      tar.scroll.slot = div.children()
    }
  },
  template: {
    autoComplete(opt, tar) {
      return $('<div class="lt-autocomplete"></div>')
    },
    li(opt, tar) {
      return $(`<li >${opt}</li>`)
    },
  },
  updater: {
    // 原生属性
    name(value, opt, tar, node) {
      tar.input.name = value
    },
    disabled(value, opt, tar, node) {
      tar.input.disabled = value
    },
    // 基本功能
    filterValue(value, opt, tar, node) {
      const result = (tar.result = tar.data.filter(({ text }) => {
        return text.indexOf(value) !== -1
      }))
      util.pullOption(opt, tar, result)
    },
    size(value, opt, tar, node) {
      tar.input.size = value
    },
  },
}

export default class AutoComplete extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      name: '', // 原生属性: name
      disabled: false, // 原生属性: 禁用(true/false)

      filterValue: '', // 基本功能: 过滤字
      size: '', // 基本功能: 尺寸
    }
    this.events = {
      reset: null, // 重置data
      click: null, // input的点击事件
      keyup: 'onKeyup', // input的键入事件
      change: 'onChange', // input的值变化事件
      focus: 'onFocus', // input的获得焦点事件
      shown: 'onShown', // 弹窗panel出现后事件
      hidden: null, // 弹窗panel隐藏后事件
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const { type } = opt
    let template
    if (type === 'button') template = util.template.select(opt, this)
    else template = util.template.autoComplete(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.input = util.pullInput(opt, this)
    this.dropdown = util.pullDropdown(opt, this)
    this.scroll = util.pullScroll(opt, this)
    this.data = this.settings.data
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    this.input.change($.proxy(this.change, this))
    this.input.click($.proxy(this.click, this))
    this.input.keyup($.proxy(this.keyup, this))
    this.input.focus($.proxy(this.focus, this))
    this.input.blur($.proxy(this.blur, this))
    this.dropdown.shown($.proxy(this.shown, this))
    this.dropdown.hidden($.proxy(this.hidden, this))
    $(window).click($.proxy(this.handleDropdown, this))
  }

  handleDropdown(event) {
    const input = $(event.target).closest(this.input.members.input)
    const dropdown = $(event.target).closest(this.dropdown.unit)
    if (input.length > 0) {
      this.dropdown.show = this.result.length > 0
    } else if (dropdown.length > 0) {
      this.dropdown.show = this.key && this.result.length > 0
    } else if (event.target.tagName === 'BODY') {
    } else if (this.dropdown.show) {
      this.dropdown.show = false
    }
  }

  handleOptionClick(value) {
    this.input.value = value
    this.change()
  }

  onShown(target) {
    if (target && target.show) {
      this.dropdown.width = this.input.unit.width()
      this.hasLocation(this.unit, this.dropdown.unit, window)
    }
  }

  onKeyup() {
    this.filterValue = this.input.value
    this.dropdown.show = this.result.length > 0
  }

  onChange() {
    this.keyup()
  }

  onFocus() {
    this.keyup()
  }

  set result(value) {
    this.settings.result = value
  }

  get result() {
    return this.settings.result || []
  }

  set data(value = this.selfData) {
    this.result = this.settings.data = value || []
    util.pullOption(this.settings, this, this.settings.data)
  }

  get data() {
    return this.settings.data
  }

  set value(value) {
    this.input.value = value
  }

  get value() {
    return this.input.value
  }

  get textContent() {
    return this.input.value
  }
}
